/* 
  日志管理
*/
import request from "@/utils/request";

//获取日志管理信息查询分页列表
export function getLog(params) {
  return request({
    url: "/log/logManage/getLog",
    method: "get",
    params
  });
}